import premiumTemplateModel from './premiumTemplateModel.vue';
import { planList } from '@/views/insurance/insuranceManage/request';
import { COLUMNSPLAN } from './../utils';
export default {
  components: {
    premiumTemplateModel
  },
  props: {
    insuranceId: {
      type: Number,
      default: 0
    },
    customerInsuranceId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      COLUMNSPLAN,
      tableData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      premiumTemplateShow: false
    };
  },
  mounted() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const obj = {
        insuranceId: this.insuranceId,
        status: 1,
        pageSize: this.pagination.pageSize,
        page: this.pagination.current
      };
      const {
        totalNum,
        items
      } = await planList(obj);
      this.pagination.total = totalNum;
      this.tableData = items;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handlePremiumTemplate(val) {
      this.premiumTemplateShow = true;
      this.$nextTick(() => {
        this.$refs.premiumTemplateRef.init(this.customerInsuranceId, val.insurancePlanId, this.customerId);
      });
    }
  }
};